import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

declare global {
  interface Window {
    _paq?: unknown[][];
  }
}

/**
 * MatomoTracker
 *
 * BrowserRouter 하위에 마운트하면 라우트 변경마다 Matomo pageview를 전송한다.
 * URL에서 projectId를 파싱해 Dimension 2로 설정한다.
 * 렌더링 결과 없음 (null 반환).
 */
export function MatomoTracker() {
  const location = useLocation();

  useEffect(() => {
    if (!window._paq) return;

    // Dimension 2: projectId — /projects/:id 패턴에서 추출
    const projectMatch = location.pathname.match(/\/projects\/([^/]+)/);
    if (projectMatch) {
      window._paq.push(['setCustomDimension', 2, projectMatch[1]]);
    } else {
      window._paq.push(['deleteCustomDimension', 2]);
    }

    window._paq.push(['setCustomUrl', location.pathname + location.search]);
    window._paq.push(['setDocumentTitle', document.title]);
    window._paq.push(['trackPageView']);
  }, [location]);

  return null;
}
